/**
 * Created by QXN on 2022/11/2.
 */
export const preventOverScroll = (dom) => {
  //滚动条是否在顶部
  var isScroll_top = true
  //滚动条是否在底部
  var isScrill_bottom = false
  var $startY
  var $moveY
  function restoreEvent(event) {
    switch (event.type) {
      case 'touchstart':
        $startY = event.touches[0].clientY
        break
      case 'touchmove':
        $moveY = event.touches[0].clientY
        //滑动距离
        var touchesY = $startY - $moveY
        //滚动条顶部
        if (isScroll_top) {
          if (touchesY < 0) {
            event.preventDefault()
          } else {
            if (dom.scrollHeight == dom.clientHeight) {
              event.preventDefault()
            } else {
              event.stopPropagation()
            }
          }
          //滚动条底部
        } else if (isScrill_bottom) {
          if (touchesY > 0) {
            event.preventDefault()
          } else {
            event.stopPropagation()
          }
        }
        break
      case 'touchend':
        break
    }
  }
  dom.addEventListener('touchstart', restoreEvent)
  dom.addEventListener('touchmove', restoreEvent)
  dom.addEventListener('touchend', restoreEvent)
  dom.addEventListener('scroll', function() {
    var contentHeight = dom.scrollHeight //内容高度
    var scrollTop = dom.scrollTop //滚动高度
    var viewHeight = dom.clientHeight
    if (scrollTop == 0) {
      isScroll_top = true
      dom.scrollTop = 0
    } else {
      isScroll_top = false
    }
    if (scrollTop / (contentHeight - viewHeight) == 1) {
      isScrill_bottom = true
      dom.scrollTop = scrollTop
    } else {
      isScrill_bottom = false
    }
  })
}
